import React from 'react';
import { KYC_QUESTION_TYPE } from './KycQuestionType';
import KycQuestionMulti from './KycQuestionMulti';
import KycQuestionSingle from './KycQuestionSingle';
import KycQuestionFreeText from './KycQuestionFreeText';

function KycQuestion({ form, question }) {
    switch (question.type) {
        case KYC_QUESTION_TYPE.MULTI:
            return <KycQuestionMulti form={form} question={question} />;
        case KYC_QUESTION_TYPE.SINGLE:
            return <KycQuestionSingle form={form} question={question} />;
        case KYC_QUESTION_TYPE.FREETEXT:
            return <KycQuestionFreeText form={form} question={question} />;
        default:
            return null;
    }
}

export default KycQuestion;
